import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './hooks/useCart';
import { HomePage } from './pages/HomePage';
import { SearchPage } from './pages/SearchPage';
import { CartPage } from './pages/CartPage';
import { WICEBTGuidePage } from './pages/WICEBTGuidePage';
export function App() {
  return <CartProvider data-id="element-0">
      <Router data-id="element-1">
        <div className="min-h-screen bg-[#FAF8F5]" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
            <Route path="/search" element={<SearchPage data-id="element-7" />} data-id="element-6" />
            <Route path="/cart" element={<CartPage data-id="element-9" />} data-id="element-8" />
            <Route path="/wic-ebt-guide" element={<WICEBTGuidePage data-id="element-11" />} data-id="element-10" />
          </Routes>
        </div>
      </Router>
    </CartProvider>;
}